import { Injectable } from "@angular/core";
import { Equipamento } from '@tivic-team/manager-ts/dist/grl';
import { EquipamentoController } from "app/controllers/grl/equipamento.controller";
import { ConcessaoVeiculoDTO } from "app/model/dtos/mob/concessao-veiculo.dto";
import { LoaderService } from 'app/services/loader.service';
import { ApiService } from './../api-service.interface';
import { EquipamentoSearch } from "./equipamento.search";

@Injectable({
    providedIn: "root",
})

export class EquipamentoService implements ApiService<Equipamento>{

    constructor(
        private _equipamentoController: EquipamentoController,
        private _loaderService: LoaderService
    ) { }

    find(search?: any): Promise<Equipamento[]> {
        throw new Error('Method not implemented.');
    }
    get(id: number): Promise<Equipamento> {
        throw new Error('Method not implemented.');
    }
    create(entity: Equipamento): Promise<Equipamento> {
        throw new Error('Method not implemented.');
    }
    update(entity: Equipamento): Promise<Equipamento> {
        throw new Error('Method not implemented.');
    }

    getEquipamentoByConcessao(search: EquipamentoSearch): Promise<Equipamento> {
        this._loaderService.show();
        return this._equipamentoController.getEquipamentoByConcessao(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    public async getEquipamentoByConcessaoVeiculo(cdConcessaoVeiculo: number): Promise<Equipamento> {
        this._loaderService.show();
        return this._equipamentoController.getEquipamentoByConcessaoVeiculo(cdConcessaoVeiculo || null).finally(() => this._loaderService.hide());
    }

    inativar(concessaoVeiculoDTO: ConcessaoVeiculoDTO): Promise<Equipamento> {
        this._loaderService.show();
        return this._equipamentoController.inativar(concessaoVeiculoDTO).finally(() => this._loaderService.hide());
    }
}
